import { render, staticRenderFns } from "./HistoryMgmtModalPanel.vue?vue&type=template&id=5412838f&scoped=true"
import script from "./HistoryMgmtModalPanel.vue?vue&type=script&lang=js"
export * from "./HistoryMgmtModalPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5412838f",
  null
  
)

export default component.exports